// extracted by mini-css-extract-plugin
export default {"subscriptionsContainer":"Subscriptions_subscriptionsContainer__LHpN+"};